// Per-module sub-nav definitions (ported from design/planning.jsx).

export type SubNavItem = { id: string; label: string; badge?: string; menuKey?: string };
export type SubNavGroup = { id: string; title: string; items: SubNavItem[] };
export type SubNav = { title: string; subtitle?: string; groups: SubNavGroup[] };

export const SUBNAVS: Record<string, SubNav> = {
  dashboard: { title: "대시보드", subtitle: "내 화면 · 위젯", groups: [
    { id: "view", title: "보기", items: [{ id: "my", label: "내 대시보드" }, { id: "team", label: "팀 대시보드" }] },
  ]},
  planning: { title: "timple", subtitle: "회사 자료 · OKR · 전략", groups: [
    { id: "company", title: "회사 정보", items: [
      { id: "general", label: "기업 일반" },
      { id: "cert", label: "인증 및 자격" },
      { id: "history", label: "연혁" },
      { id: "org", label: "조직 구성" },
    ]},
    { id: "biz", title: "사업 자료", items: [
      { id: "portfolio", label: "포트폴리오" },
      { id: "performance", label: "실적" },
      { id: "tech", label: "보유 기술" },
      { id: "partners", label: "주요 파트너" },
    ]},
    { id: "okr", title: "OKR", items: [
      { id: "okr", label: "목표 · KR" },
      { id: "initiatives", label: "이니셔티브" },
    ]},
  ]},
  notice: { title: "공지사항", subtitle: "사내 공지 · 카테고리", groups: [
    { id: "cat", title: "카테고리", items: [
      { id: "GENERAL", label: "일반" },
      { id: "URGENT", label: "긴급" },
      { id: "EVENT", label: "이벤트" },
      { id: "IT", label: "IT" },
      { id: "HR", label: "HR" },
    ]},
  ]},
  mail: { title: "메일", subtitle: "받은함 · 보낸함", groups: [
    { id: "folders", title: "폴더", items: [
      { id: "INBOX", label: "받은 메일함" },
      { id: "STARRED", label: "별표 표시" },
      { id: "IMPORTANT", label: "중요 메일" },
      { id: "SENT", label: "보낸 메일함" },
      { id: "DRAFT", label: "임시 보관함" },
      { id: "SCHEDULED", label: "예약 발송" },
      { id: "SPAM", label: "스팸함" },
      { id: "TRASH", label: "휴지통" },
    ]},
    { id: "ext", title: "외부 계정", items: [
      { id: "accounts", label: "IMAP 계정 연결" },
      { id: "shared", label: "공용 편지함" },
    ]},
  ]},
  msg: { title: "채팅", subtitle: "채팅방", groups: [
    { id: "rooms", title: "내 채팅방", items: [{ id: "all", label: "전체" }, { id: "direct", label: "1:1" }, { id: "group", label: "그룹" }] },
  ]},
  // 캘린더는 페이지 내부에 자체 사이드바(CalSidebar: 미니달력·필터·구글·자원)를 가지므로
  // 별도 글로벌 서브내브를 두지 않는다(중복/오작동 제거).
  proj: { title: "프로젝트", subtitle: "단계별 관리", groups: [
    { id: "manage", title: "프로젝트 관리", items: [
      { id: "all",      label: "전체 프로젝트" },
      { id: "mine",     label: "내 프로젝트" },
      { id: "active",   label: "진행 중" },
      { id: "archived", label: "완료/아카이브" },
    ]},
    { id: "plan1", title: "기획 단계", items: [
      { id: "idea",        label: "아이디어 제안" },
      { id: "requirement", label: "요구사항 정의" },
      { id: "feasibility", label: "사전 검토" },
    ]},
    { id: "plan2", title: "계획 단계", items: [
      { id: "wbs",      label: "WBS · 일정" },
      { id: "budget",   label: "예산 계획" },
      { id: "resource", label: "리소스 배정" },
    ]},
    { id: "ops", title: "운영 단계", items: [
      { id: "progress", label: "진행 현황" },
      { id: "issue",    label: "이슈 · 리스크" },
      { id: "change",   label: "변경 관리" },
    ]},
    { id: "eval", title: "평가 및 보고", items: [
      { id: "milestone", label: "마일스톤 보고" },
      { id: "closeout",  label: "완료 보고서" },
      { id: "retro",     label: "사후 회고" },
    ]},
    { id: "etc", title: "기타", items: [
      { id: "archive", label: "자료실" },
      { id: "notice",  label: "프로젝트 공지" },
    ]},
  ]},
  board: { title: "게시판", subtitle: "사내 커뮤니티", groups: [
    { id: "cat", title: "카테고리", items: [
      { id: "",       label: "전체" },
      { id: "FREE",   label: "자유" },
      { id: "PRAISE", label: "칭찬" },
      { id: "QA",     label: "Q&A" },
      { id: "CLUB",   label: "동호회" },
      { id: "MARKET", label: "장터" },
      { id: "ANON",   label: "익명" },
    ]},
    { id: "my", title: "내 게시글", items: [
      { id: "myposts",    label: "내가 쓴 글" },
      { id: "mycomments", label: "내 댓글" },
    ]},
  ]},
  programs: { title: "프로그램", subtitle: "서비스 카탈로그", groups: [
    { id: "cat", title: "카테고리", items: [
      { id: "",       label: "전체" },
      { id: "기획",   label: "기획" },
      { id: "계획",   label: "계획" },
      { id: "디자인", label: "디자인" },
      { id: "영상",   label: "영상" },
      { id: "기타",   label: "기타" },
    ]},
    { id: "my", title: "내 예약", items: [
      { id: "bookings", label: "예약 내역" },
    ]},
  ]},
  // todos: rendered via <TodosSidebar/> (page-tree). No static subnav.
  ref: { title: "레퍼런스", subtitle: "이미지 · 자료", groups: [
    // Categories are loaded dynamically from the DB (REFERENCE folders) and
    // managed inline (팀장급 이상). This static entry is just the fallback header.
    { id: "cat", title: "카테고리", items: [
      { id: "", label: "전체" },
    ]},
  ]},
  drive: { title: "드라이브", subtitle: "파일 · 폴더", groups: [
    { id: "scope", title: "범위", items: [
      { id: "personal", label: "개인" }, { id: "department", label: "부서" }, { id: "company", label: "전사" }, { id: "shared", label: "공유 링크" },
    ]},
  ]},
  approval: { title: "결재", subtitle: "결재함 · 양식", groups: [
    { id: "inbox", title: "결재함", items: [
      { id: "waiting", label: "결재 대기", badge: "3" },
      { id: "in_progress", label: "진행 중" },
      { id: "completed", label: "완료" },
      { id: "rejected", label: "반려" },
      { id: "referenced", label: "수신/참조" },
    ]},
    { id: "new", title: "작성", items: [{ id: "new", label: "새 결재 작성" }] },
  ]},
  att: { title: "근태", subtitle: "출퇴근 · 연장", groups: [
    { id: "my", title: "내 근태", items: [{ id: "today", label: "오늘" }, { id: "month", label: "이번 달" }, { id: "overtime", label: "연장근무" }] },
  ]},
  leave: { title: "휴가", subtitle: "연차 · 신청", groups: [
    { id: "me", title: "내 휴가", items: [{ id: "balance", label: "잔여 연차" }, { id: "requests", label: "신청 이력" }, { id: "new", label: "휴가 신청" }] },
  ]},
  dir: { title: "임직원", subtitle: "조직도 · 검색", groups: [
    { id: "view", title: "보기", items: [{ id: "list", label: "👥 임직원 목록" }, { id: "org", label: "🏢 조직도" }] },
  ]},
  hr: { title: "급여", subtitle: "명세서 · 계산", groups: [
    { id: "me", title: "내 명세서", items: [{ id: "current", label: "이번 달" }, { id: "history", label: "이력" }] },
    { id: "admin", title: "관리", items: [{ id: "compute", label: "월 일괄 계산" }, { id: "publish", label: "명세서 발송" }] },
  ]},
  expense: { title: "경비", subtitle: "지출결의 · 정산", groups: [
    { id: "me", title: "내 청구", items: [{ id: "all", label: "전체" }, { id: "pending", label: "대기" }, { id: "approved", label: "승인" }] },
  ]},
  crm: { title: "거래처", subtitle: "고객사 · 계약", groups: [
    { id: "cat", title: "분류", items: [
      { id: "CUSTOMER", label: "고객사" }, { id: "SUPPLIER", label: "공급사" }, { id: "PARTNER", label: "파트너" },
    ]},
    { id: "ct", title: "계약", items: [{ id: "all", label: "전체 계약" }, { id: "expiring", label: "만료 임박" }] },
  ]},
  finance: { title: "재무", subtitle: "매출 · 매입 · 자금", groups: [
    { id: "j", title: "전표", items: [{ id: "sales", label: "매출" }, { id: "purchase", label: "매입" }] },
    { id: "rep", title: "보고", items: [{ id: "cash", label: "자금일보" }, { id: "ar", label: "미수금" }, { id: "ap", label: "미지급금" }] },
  ]},
  bi: { title: "경영 BI", subtitle: "임원 대시보드", groups: [
    { id: "view", title: "보기", items: [
      { id: "summary", label: "요약" },
      { id: "cashflow", label: "자금 현황" },
      { id: "headcount", label: "인력 현황" },
    ]},
  ]},
  // ── 내부운영 (임원 전용) ────────────────────────────────────────────
  exec_hr: { title: "인사관리", subtitle: "채용 · 평가 · 급여", groups: [
    { id: "overview", title: "개요", items: [
      { id: "kpis", label: "KPI 현황" },
      { id: "funnel", label: "채용 현황" },
      { id: "positions", label: "채용 포지션" },
    ]},
    { id: "ops", title: "운영", items: [
      { id: "eval", label: "평가 대기" },
      { id: "payroll", label: "급여 현황" },
    ]},
  ]},
  exec_biz: { title: "내부경영", subtitle: "전략 · 이사회 · 자금", groups: [
    { id: "kpis", title: "KPI", items: [
      { id: "summary", label: "경영 요약" },
      { id: "cashflow", label: "자금 흐름" },
    ]},
    { id: "strategy", title: "전략", items: [
      { id: "initiatives", label: "전략 이니셔티브" },
      { id: "board", label: "이사회 일정" },
    ]},
  ]},
  // exec_docs: 내부문서는 DriveSidebar(SECRET 스코프 폴더 트리)를 사용 — 정적 서브내브 불필요.
  notif: { title: "알림", subtitle: "인앱 알림", groups: [
    { id: "f", title: "필터", items: [{ id: "all", label: "전체" }, { id: "unread", label: "안 읽음" }] },
  ]},
  settings: { title: "환경설정", subtitle: "개인 설정", groups: [
    { id: "acct", title: "계정", items: [{ id: "profile", label: "프로필" }, { id: "security", label: "계정·보안" }, { id: "notif", label: "알림" }] },
    { id: "look", title: "외관·지역", items: [{ id: "theme", label: "테마·외관" }, { id: "lang", label: "언어·지역" }, { id: "work", label: "근무 설정" }] },
    { id: "etc",  title: "기타", items: [{ id: "sig", label: "메일 서명" }, { id: "keys", label: "단축키" }, { id: "data", label: "데이터" }] },
  ]},
  admin: { title: "시스템 관리", subtitle: "관리자 전용", groups: [
    { id: "overview", title: "개요", items: [{ id: "overview", label: "관리자 개요", menuKey: "system_admin" }] },
    { id: "menu",     title: "메뉴", items: [
      { id: "menu-perms", label: "메뉴 권한 관리", menuKey: "menu_admin" },
    ]},
    { id: "iam",      title: "IAM",  items: [
      { id: "users", label: "사용자", menuKey: "system_admin" },
      { id: "departments", label: "부서/조직", menuKey: "system_admin" },
      { id: "roles", label: "역할/권한", menuKey: "system_admin" },
    ]},
    { id: "security", title: "보안", items: [
      { id: "policies", label: "보안 정책", menuKey: "system_admin" },
      { id: "audit", label: "감사 로그", menuKey: "system_admin" },
      { id: "ai", label: "AI 모델", menuKey: "system_admin" },
    ]},
    { id: "ops",      title: "운영", items: [
      { id: "backup", label: "백업/복원", menuKey: "system_admin" },
      { id: "kms", label: "KMS 회전", menuKey: "system_admin" },
      { id: "integrations", label: "통합/API", menuKey: "system_admin" },
      { id: "webhooks", label: "Webhooks", menuKey: "system_admin" },
      { id: "health", label: "시스템 상태", menuKey: "system_admin" },
      { id: "license", label: "라이선스", menuKey: "system_admin" },
      { id: "mail-domain", label: "메일 도메인 설정", menuKey: "system_admin" },
    ]},
    { id: "approval", title: "결재", items: [
      { id: "forms", label: "양식 빌더", menuKey: "system_admin" },
    ]},
  ]},
};
